export default __webpack_public_path__ + "static/media/plus.d0d0f358.svg";